import { type FC, type ReactNode } from "react";
import { Plus } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import searchAccountsIllustration from "@/shared/assets/illustrations/search_accounts.svg";

interface EmptyStateProps {
  title: string;
  description?: string;
  illustration?: string;
  actionLabel?: string;
  onAction?: () => void;
  children?: ReactNode;
}

export const EmptyState: FC<EmptyStateProps> = ({
  title,
  description,
  illustration = searchAccountsIllustration,
  actionLabel,
  onAction,
  children,
}) => {
  return (
    <div className="flex flex-col items-center gap-2 px-6 py-8">
      <img src={illustration} alt={title} className="h-[100px] w-[100px]" />
      <p className="text-base font-medium">{title}</p>
      {description && <p className="text-center text-sm text-secondary">{description}</p>}
      {actionLabel && onAction && (
        <Button variant="outline" onClick={onAction} className="mt-2">
          <Plus className="h-4 w-4" /> {actionLabel}
        </Button>
      )}
      {children}
    </div>
  );
};
